<template>
  <div>
    <header
      v-if="fromMap"
      class="card-header is-border-bottom">
      <div class="is-padding columns is-gapless is-vcentered">
        <p class="column is-narrow card-header-title is-size-3">
          {{ p.name }}
        </p>
        <div class="column is-margin-left-xsmall">
          <span
            v-if="isAdmin && isPromoteur"
            class="tag is-xsmall"
            :class="p.status | programStatusClass">{{ p.status | workflowLabel }}</span>
        </div>
      </div>
    </header>
    <div class="columns is-gapless">
      <div
        class="column"
        :class="fromMap ? 'is-one-third is-4' : 'is-narrow is-border-left is-border-top is-border-bottom has-background-light'"
        style="width: 270px; max-width: 33%;">
        <router-link
          :to="{name: 'ProgramVue', params: {id: p.pk}}"
          class="is-block">
          <figure
            class="image is-4by3 is-margin-auto has-tag has-tag--top-leftout"
            :class="{'is-disabled': p.status === 'draft'}">
            <div
              v-if="!fromMap"
              class="tags columns is-column is-gapless is-align-items-flex-start">
              <span
                v-if="p.progress_step"
                class="tag is-info is-radiusless"> {{ p.progress_step | programStepProgressLabel }} </span>
              <template v-if="p.tags && p.tags.length">
                <span
                  v-for="(t, i) in p.tags.slice(0, 3)"
                  :key="i"
                  class="tag is-annonce is-radiusless">{{ t | truncate }}</span>
              </template>
            </div>
            <div v-if="p.picture && p.picture.cloudinary_id">
              <v-lazy-image
                v-if="!fromMap"
                :src="p.picture | smallImage"
                :src-placeholder="programPicturePlaceholder" />
              <img
                v-else
                :src="p.picture.path">
            </div>
            <div v-else>
              <img :src="programPicturePlaceholder">
            </div>
          </figure>
        </router-link>
        <div
          v-if="!p.is_optionable && !fromMap"
          class="columns has-background-annonce is-vcentered is-gapless is-padding-left-small">
          <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xsmall">
            <span class="icon has-text-white"><i class="fas fa-engine-warning fa-lg" /></span>
          </div>
          <div class="column is-paddingless-left is-padding-top-xsmall is-padding-bottom-xsmall">
            <div class="has-text-white is-italic is-size-6 has-text-weight-medium">
              <span>Non optionnable</span>
            </div>
          </div>
        </div>
        <router-link
          v-if="fromMap"
          :to="{name: 'ProgramVue', params: {id: p.pk}}"
          class="button is-primary is-fullwidth is-margin-top-xsmall">
          Fiche {{ nameToUse }}
        </router-link>
      </div>
      <div
        class="column"
        :class="fromMap ? 'is-two-thirds is-8' : 'is-border'">
        <div
          v-if="!fromMap"
          class="columns is-gapless is-padding-left is-align-items-flex-start is-margin-bottom-xsmall">
          <div class="column is-padding-top-small">
            <router-link
              :to="{name: 'ProgramVue', params: {id: p.pk}}"
              class="title is-3 is-marginless is-inline-flex is-vcentered">
              <b>{{ p.name }}</b>
            </router-link>
            <div class="title is-7 is-marginless is-padding-top-xxsmall">
              <div class="has-text-grey is-size-6 is-flex">
                <span
                  v-if="isAdmin && isPromoteur && !fromMap"
                  class="is-self-centered">Date de création : {{ p.created_on | prettyDate }}</span>
                <span
                  v-if="isAdmin && isPromoteur"
                  class="tag is-xsmall is-margin-left-small"
                  :class="p.status | programStatusClass">
                  {{ p.status | workflowLabel }}
                </span>
              </div>
            </div>
            <div
              v-if="p.promoteur && isDistributeur"
              class="is-size-6">
              <!-- Promoteur : -->
              <router-link
                v-if="accounts.find(a=>a.name===p.promoteur.name).promoteur_details_activated"
                class="is-linkTextPicto"
                :to="{name: 'PromoteurPresentation', params: {id: p.promoteur.pk}}">
                <span class="">{{ p.promoteur.name }}</span>
              </router-link>
              <span
                v-else
                class="has-text-weight-medium">{{ p.promoteur.name }}</span>
            </div>
          </div>
          <div
            v-if="program.status !== 'archived'"
            class="column is-narrow is-border-left is-border-bottom">
            <display-button-list
              v-if="!multiselection && !isDistributeur"
              :buttons="buttonList"
              :data="p"
              :classes="'button is-square is-white is-borderless is-action is-radiusless'"
              :hide-text-when-solo="true" />
            <multiselect-button
              v-if="multiselection"
              :data="p"
              :multiselection-class="'is-square is-radiusless'" />
          </div>
        </div>
        <div
          v-if="fromMap && isDistributeur"
          class="is-margin-top-small is-padding-right is-padding-left is-size-6">
          Promoteur : <span class="has-text-weight-medium">{{ p.promoteur.name }}</span>
        </div>
        <div class="is-margin-top-small is-padding-right is-padding-left is-size-5 ">
          <div class="columns is-gapless is-marginless">
            <div class="column">
              <p>
                <span class="icon is-small is-margin-right-xsmall"><i class="far fa-landmark" /></span>
                Dispositif(s) : <b v-if="taxDispositifs">{{ taxDispositifs }}</b><span v-else>Aucun</span>
                <span
                  v-if="isPromoteur"
                  class="is-margin-left-xsmall">
                  - Tx Comm. : <b v-if="p.remuneration">{{ p.remuneration }} %</b><span v-else>NC</span>
                </span>
              </p>
              <p class="is-padding-top-xxsmall">
                <span
                  class="icon is-small is-margin-right-xsmall"
                  :class="actableStatus.color">
                  <i
                    class="fas"
                    :class="actableStatus.icon" />
                </span>
                <span :class="actableStatus.color">Actable</span>
                <span class="is-padding-left-xxsmall">
                  - Livraison :
                  <b v-if="p.date_livraison">{{ p.date_livraison | prettyTrimestreLong }}</b>
                  <span v-else>NC</span>
                </span>
              </p>
              <div class="is-size-6 is-padding-top-small">
                <span v-if="fromTo.toType && (fromTo.fromType !== fromTo.toType)">
                  Du <span v-if="fromTo.fromType === 'parking'">Parking</span>
                  <span v-else>{{ fromTo.fromType | lotTypeLabel }}</span> au
                  <span v-if="fromTo.toType === 'parking'">Parking</span>
                  <span v-else>{{ fromTo.toType | lotTypeLabel }}</span> -
                </span>
                <span v-else-if="fromTo.fromType">
                  <span v-if="fromTo.fromType === 'parking'">Parking</span><span
                    v-else>{{ fromTo.fromType | lotTypeLabel }}</span> -
                </span>
                <span v-if="fromTo.toPrice && (fromTo.fromPrice !== fromTo.toPrice)">
                  de {{ fromTo.fromPrice | prettyPrice }} € à {{ fromTo.toPrice | prettyPrice }} €
                </span>
                <span v-else-if="fromTo.fromPrice">à partir de {{ fromTo.fromPrice | prettyPrice }} €</span>
              </div>
            </div>
            <div
              class="column is-narrow"
              :class="{'is-minW130p': !fromMap}">
              <figure v-if="p.promoteur.picture && isDistributeur">
                <img
                  :src="p.promoteur.picture.cloudinary_id | cloudinary({width: 'auto', height: 80, width: 200, crop: 'limit', quality: '90', dpr: '2'})"
                  style="max-height:80px">
              </figure>
            </div>
          </div>
          <div class="truncate">
            <p class="is-size-6">
              <b>Adresse : </b><span
                v-if="p.address">{{ p.address.line1 }} {{ p.address.zip_code }} {{ p.address.city }}</span><span
                v-else>NC</span>
            </p>
          </div>
        </div>
        <div class="is-margin-top" />
        <template v-if="lotResume && priceBySize && isAdmin && isPromoteur">
          <router-link
            v-for="(info, i) in priceBySize"
            :key="i"
            :to="{name: 'ProgramLots', params: {id: p.pk}}"
            class="columns is-gapless is-padding-right is-padding-left is-padding-top-xxsmall is-padding-bottom-xxsmall is-border-top is-border--light is-marginless">
            <template v-if="info.cheapest_lot && info.cheapest_lot.sale_price_ttc">
              <div class="column is-4">
                <b v-if="info.type === 'parking'">Parking</b>
                <b v-else>Lot {{ info.type | lotTypeLabel }}</b>
              </div>
              <div class="column is-6">
                <span v-if="info.highest_lot && info.cheapest_lot && (info.cheapest_lot.sale_price_ttc !== info.highest_lot.sale_price_ttc)">
                  de {{ info.cheapest_lot.sale_price_ttc | prettyPrice }} € à {{ info.highest_lot.sale_price_ttc | prettyPrice }} €
                </span>
                <span v-else-if="info.cheapest_lot">à partir de {{ info.cheapest_lot.sale_price_ttc | prettyPrice }} €</span>
              </div>
              <div class="column is-2">
                <div>{{ info.count }} lot<span v-if="info.count > 1">s</span></div>
              </div>
            </template>
          </router-link>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { compact, head, last, orderBy, uniq } from 'lodash'
import { DefaultValues, Multiselection } from '@/mixins'
import ProgramListMixin from './ProgramListMixin'
import { mapGetters } from 'vuex'

export default {
  name: 'ProgramCard',
  mixins: [
    DefaultValues,
    Multiselection,
    ProgramListMixin
  ],
  props: {
    program: {
      type: Object,
      required: true
    },
    sourceLots: {
      type: Array,
      required: true
    },
    fromMap: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['accounts']),
    p () {
      return this.program
    },
    nameToUse () {
      if (this.program && this.program.is_amenagement) {
        return 'lotissement'
      } else {
        return 'programme'
      }
    },
    taxDispositifs () {
      if (!this.p || !this.p.tax_dispositifs || !this.p.tax_dispositifs.length) return
      if (!this.taxDispositifsData) return
      let data = uniq(compact(this.p.tax_dispositifs.map(x => {
        if (this.taxDispositifsData[x]) {
          return this.taxDispositifsData[x].label
        }
      })))
      return data.join(', ')
    },
    actableStatus () {
      let trim = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]]
      let date = new Date()
      let currentTrim = `${date.getFullYear()}${trim.findIndex(x => x.includes(date.getMonth())) + 1}`
      if (!this.p.date_actabilite) {
        return { icon: 'fa-question-circle', color: 'has-text-black' }
      } else if (currentTrim > this.p.date_actabilite) {
        return { icon: 'fa-check-circle', color: 'has-text-success' }
      } else if (currentTrim <= this.p.date_actabilite) {
        return { icon: 'fa-times-circle', color: 'has-text-warning' }
      }
      return null
    },
    fromTo () {
      let fromTo = { fromType: null, toType: null, fromPrice: null, toPrice: null }
      let first = head(this.priceBySize)
      let end = last(this.priceBySize)
      if (first && first.type) fromTo.fromType = first.type
      if (end && end.type) fromTo.toType = end.type
      if (first && first.cheapest_lot && first.cheapest_lot.sale_price_ttc) {
        fromTo.fromPrice = first.cheapest_lot.sale_price_ttc
      }
      if (end && end.highest_lot && end.highest_lot.sale_price_ttc) {
        fromTo.toPrice = end.highest_lot.sale_price_ttc
      }
      return fromTo
    },
    priceBySize () {
      if (!this.lotResume || !this.lotResume.price_by_size) return
      let data = []
      for (let [key, value] of Object.entries(this.lotResume.price_by_size)) {
        data.push({
          type: key,
          ...value
        })
      }
      return orderBy(data, 'type', 'asc')
    },
    lotResume () {
      return this.program.lot_resume
    }
  },
  methods: {
    openModalTicket () {
      if (!(this.isPromoteur && this.isAdmin)) {
        let params = {
          defaultSubject: 'program_information',
          defaultTitle: this.nameToUse + ' ' + this.program.name,
          promoteur: this.program.promoteur.pk
        }
        this.$store.commit('setModal', { mode: 'CREATE_TICKET', params })
      }
    }
  }
}
</script>
